module.exports = __webpack_public_path__ + "static/media/nexone-logo-color.f3082b4e.png";